/* eslint-disable import/prefer-default-export */
import { isValidEmail } from '@/helpers/utils';
import { ERROR } from './constants';

export const validatePlant = (plant, addToast, t) => {
  const { mailbox, wkzNumber, plantName } = plant;
  let canBeCreated = true;

  if (!isValidEmail(mailbox)) {
    addToast(t('validations.formatEmail'), ERROR);
    canBeCreated = false;
  }

  if (wkzNumber.length !== 4) {
    addToast(t('validations.formatWKZ'), ERROR);
    canBeCreated = false;
  }

  if (!plantName) {
    addToast(t('validations.plantNameRequired'), ERROR);
    canBeCreated = false;
  }

  return canBeCreated;
};

export const validateProductGroup = (productGroup, addToast, t) => {
  const { name, plants, coordinators } = productGroup;
  let canBeCreated = true;

  if (name.length !== 10) {
    addToast(t('validations.formatProductGroupName'), ERROR);
    canBeCreated = false;
  }

  if (plants.length === 0) {
    addToast(t('validations.plantsRequired'), ERROR);
    canBeCreated = false;
  }

  if (coordinators.length === 0) {
    addToast(t('validations.coordinatorsRequired'), ERROR);
    canBeCreated = false;
  }

  return canBeCreated;
};

export const validateProductGroupMGC = (productGroup, addToast, t) => {
  const { coordinators, mailboxes } = productGroup;
  let canBeCreated = true;

  if (coordinators.length === 0) {
    addToast(t('validations.coordinatorsRequired'), ERROR);
    canBeCreated = false;
  }

  if (!mailboxes || (mailboxes && mailboxes.split(',').some((mail) => !isValidEmail(mail)))) {
    addToast(t('validations.formatEmail'), ERROR);
    canBeCreated = false;
  }

  return canBeCreated;
};

export const validateSUMSCriteria = (criteria, allCriterias, addToast, t, isEdit) => {
  const { efaNumber } = criteria;
  let canBeCreated = true;

  if (!isEdit && allCriterias.some((c) => c.efaNumber === efaNumber)) {
    addToast(t('validations.SUMSCriteriaDuplicated'), ERROR);
    canBeCreated = false;
  }

  return canBeCreated;
};
